import React, {useState, useEffect} from "react"
import GenericModal from "@irati/ui/src/GenericModal"

import authentication from "@irati/auth"
import OnboardingService from "@irati/onboarding/services/onboarding"
import OnboardingStep from "@irati/onboarding/enums/Step"
import recognitionTracking from "@irati-tracking/recognition/recognition"

import Content from "./Content"

const LEGACY_ONBOARDING_STORAGE_KEY = "hideOnboarding"

const Onboarding = () => {
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    // Moved from LocalStorage -> graph (Feb-2020), check kept to avoid double tours
    const showModalLegacyCheck = localStorage.getItem(LEGACY_ONBOARDING_STORAGE_KEY)
    if (!authentication.isUserGhost()) {
      OnboardingService.get(authentication.user().uuid).then((res) => {
        const showTourModal = res.userProgress?.find(({step}) => {
          return step === OnboardingStep.HAS_COMPLETED_FIRST_RECOGNITION_TOUR
        })
        // If the service thinks the user should see the tour but they have the LocalStorage, fire an update
        if (!showTourModal && showModalLegacyCheck) {
          completeTour()
        } else {
          setShowModal(!showTourModal)
        }
      })
    }
  }, [])
  useEffect(() => {
    if (showModal) {
      recognitionTracking.viewOnboarding()
    }
  }, [showModal])

  const completeTour = () => OnboardingService.completeStep(authentication.user(), OnboardingStep.HAS_COMPLETED_FIRST_RECOGNITION_TOUR)

  const hide = () => {
    recognitionTracking.dismissOnboarding()
    closeModal()
  }

  const closeModal = () => {
    completeTour()
    setShowModal(false)
  }

  return (
    <GenericModal show={showModal} onHide={hide} hideActions>
      <Content closeModal={closeModal} />
    </GenericModal>
  )
}

export default Onboarding
